export default {"src":"/_next/static/media/Pending.fa789bc5.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};